import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import { FaEdit, FaRegTrashAlt, FaSearchPlus } from 'react-icons/fa';
import { SignalKinds } from '../../../../data/constants/SignalsKinds';
import { useAssignmentData } from '../../../assignment/AssignmentsContext';
import { useDispatch } from '../../../context/DispatchContext';
import Select from '../../../elements/Select';
import { useModal, positions, transitions, } from '../../../elements/popup/Modal';
import EditZoneModal from '../../../modal/editZone/EditZoneModal';
const selectBoxStyle = {
    marginLeft: 2,
    marginRight: 2,
    border: 'none',
    height: '20px',
};
function ActionsColumn({ rowData, rowSpanTags }) {
    const dispatch = useDispatch();
    const assignmentData = useAssignmentData();
    const modal = useModal();
    const changeSignalKindHandler = useCallback((kind) => {
        dispatch({
            type: 'CHANGE_ZONE_SIGNAL_KIND',
            payload: {
                zoneData: rowData,
                kind,
            },
        });
    }, [dispatch, rowData]);
    const deleteZoneHandler = useCallback(() => {
        dispatch({
            type: 'DELETE_2D_ZONE',
            payload: {
                id: rowData.id,
                assignmentData,
            },
        });
    }, [assignmentData, dispatch, rowData]);
    const zoomZoneHandler = useCallback(() => {
        const xMargin = Math.abs(rowData.x.from - rowData.x.to) * 10;
        dispatch({
            type: 'SET_X_DOMAIN',
            payload: {
                xDomain: rowData.x.from <= rowData.x.to
                    ? [rowData.x.from - xMargin, rowData.x.to + xMargin]
                    : [rowData.x.to - xMargin, rowData.x.from + xMargin],
            },
        });
        const yMargin = Math.abs(rowData.y.from - rowData.y.to) * 10;
        dispatch({
            type: 'SET_Y_DOMAIN',
            payload: {
                yDomain: rowData.y.from <= rowData.y.to
                    ? [rowData.y.from - yMargin, rowData.y.to + yMargin]
                    : [rowData.y.to - yMargin, rowData.y.from + yMargin],
            },
        });
    }, [dispatch, rowData.x.from, rowData.x.to, rowData.y.from, rowData.y.to]);
    const saveEditZoneHandler = useCallback((zone) => {
        dispatch({
            type: 'SAVE_EDITED_ZONE',
            payload: {
                zone,
            },
        });
    }, [dispatch]);
    const openEditZoneHandler = useCallback(() => {
        dispatch({
            type: 'SET_SELECTED_TOOL',
            payload: { selectedTool: 'editRange' },
        });
        modal.show(_jsx(EditZoneModal, { onCloseEditZoneModal: () => modal.close(), onSaveEditZoneModal: saveEditZoneHandler, onZoomEditZoneModal: () => zoomZoneHandler(), rowData: rowData }), {
            position: positions.MIDDLE_RIGHT,
            transition: transitions.SCALE,
            isBackgroundBlur: false,
        });
    }, [dispatch, modal, rowData, saveEditZoneHandler, zoomZoneHandler]);
    return (_jsxs(Fragment, { children: [_jsx("td", { children: _jsx(Select, { onChange: (value) => {
                        changeSignalKindHandler(value);
                    }, items: SignalKinds, defaultValue: rowData.tableMetaInfo.signal.kind, style: selectBoxStyle }) }), _jsxs("td", { ...rowSpanTags, children: [_jsx("button", { type: "button", className: "delete-button", onClick: deleteZoneHandler, children: _jsx(FaRegTrashAlt, {}) }), _jsx("button", { type: "button", className: "zoom-button", onClick: zoomZoneHandler, children: _jsx(FaSearchPlus, { title: "Zoom to zone in spectrum" }) }), _jsx("button", { type: "button", className: "edit-button", onClick: openEditZoneHandler, children: _jsx(FaEdit, { color: "blue" }) })] })] }));
}
export default ActionsColumn;
